import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelAccountSelectionController from 'lumen/controllers/hotel/account-selection';
import type { Transition } from 'lumen/services/transition';

export default class HotelAccountSelectionRoute extends Route {
  queryParams = {
    redirectTo: {
      refreshModel: false,
    },
  };
  @service declare navigation: Services['navigation'];
  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    const redirectTo = transition.to.queryParams['redirectTo'] as
      | string
      | undefined;

    if (!redirectTo) {
      this.transition.redirectToEnabledTab(transition);
      return;
    }

    if (this.navigation.getSubscriptionsForRoute(redirectTo).length === 0) {
      this.transition.redirectToEnabledTab(transition);
    }
  }

  resetController(
    controller: HotelAccountSelectionController,
    isExiting: boolean,
  ): void {
    if (isExiting) {
      controller.redirectTo = null;
    }
  }
}
